var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.82209 7.50205L14.7141 1.60982C14.9575 1.37473 15.0551 1.02661 14.9695 0.699245C14.8838 0.371882 14.6281 0.116226 14.3007 0.0305387C13.9734 -0.0551486 13.6253 0.0424679 13.3902 0.285869L7.49789 6.17787L1.60585 0.285869C1.23908 -0.0728445 0.651939 -0.0696111 0.289141 0.29312C-0.0736578 0.655852 -0.0769951 1.24299 0.281656 1.60982L6.17393 7.50205L0.281656 13.3943C0.0407214 13.6299 -0.0549888 13.9769 0.0310504 14.3027C0.11709 14.6285 0.371602 14.883 0.697462 14.969C1.02332 15.055 1.37025 14.9592 1.60585 14.7182L7.49789 8.82623L13.3902 14.7182C13.573 14.901 13.8127 14.9926 14.0521 14.9926C14.2916 14.9926 14.5315 14.901 14.7141 14.7182C15.0797 14.3526 15.0797 13.7599 14.7141 13.3943L8.82209 7.50205Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.24bc373d66abb4896aaaa9785dee59de.svg";
export { ForwardRef as ReactComponent };